module.exports = __webpack_public_path__ + "static/media/02.70387b6a.jpg";